export default __webpack_public_path__ + "static/media/ic-novos-pedidos.c8bca475.svg";